import collectionReducer from '../collectionReducer';

export default collectionReducer({
    collectionActionName: 'APM_MODELS',
    itemActionName: 'APM_MODEL',
});
